export const cities = [
  {
    slug: 'versailles',
    name: 'Versailles',
    zipCode: '78000',
    population: '85.000',
    landmark: 'du Château de Versailles',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'sartrouville',
    name: 'Sartrouville',
    zipCode: '78500',
    population: '52.000',
    landmark: 'du Théâtre de Sartrouville',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'poissy',
    name: 'Poissy',
    zipCode: '78300',
    population: '38.000',
    landmark: 'du Parc Meissonier',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'saint-germain-en-laye',
    name: 'Saint-Germain-en-Laye',
    zipCode: '78100',
    population: '45.000',
    landmark: 'du Château de Saint-Germain',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'mantes-la-jolie',
    name: 'Mantes-la-Jolie',
    zipCode: '78200',
    population: '44.000',
    landmark: 'de la Collégiale Notre-Dame',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'plaisir',
    name: 'Plaisir',
    zipCode: '78370',
    population: '31.000',
    landmark: 'du Parc des Sports',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'les-mureaux',
    name: 'Les Mureaux',
    zipCode: '78130',
    population: '32.000',
    landmark: 'de l\'Écomusée',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'conflans-sainte-honorine',
    name: 'Conflans-Sainte-Honorine',
    zipCode: '78700',
    population: '36.000',
    landmark: 'du Musée de la Batellerie',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'trappes',
    name: 'Trappes',
    zipCode: '78190',
    population: '32.000',
    landmark: 'de la Merise',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  },
  {
    slug: 'houilles',
    name: 'Houilles',
    zipCode: '78800',
    population: '32.000',
    landmark: 'du Parc du Château',
    spinContent: {
      intro: [
        'Votre entreprise à {city} mérite une présence digitale à la hauteur de son ambition',
        'Développez votre activité à {city} avec un site web qui convertit vraiment',
        'Propulsez votre business à {city} grâce à une stratégie web performante'
      ],
      expertise: [
        'Nos experts web basés dans les Yvelines accompagnent les entreprises de {city}',
        'Notre agence digitale intervient directement à {city} pour votre réussite',
        'Spécialistes du web local, nous comprenons les enjeux des entreprises de {city}'
      ],
      cta: [
        'Rencontrons-nous à {city} pour discuter de votre projet',
        'Obtenez un devis gratuit pour votre projet web à {city}',
        'Parlons de votre stratégie digitale autour d\'un café à {city}'
      ]
    }
  }
];

// Fonction pour récupérer une variante aléatoire
export const getSpinVariant = (variants, seed = '') => {
  const index = Math.abs(seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)) % variants.length;
  return variants[index];
};

// Fonction pour remplacer les placeholders
export const replacePlaceholders = (text, cityName) => {
  return text.replace(/{city}/g, cityName);
};
